import { createFileRoute } from '@tanstack/react-router'
import { SavedQueryProvider, SavedQueryState } from '~/features/saved-query'
import { DEFAULT_INITIAL_VALUE } from '~/features/saved-query/constants'
import { useTitle } from '~/hooks'

import { ExploreCurrentView } from './-components/current-view'
import { ExploreViews } from './-components/views'

const INITIAL_VALUE = {
  ...DEFAULT_INITIAL_VALUE,
  filters: [
    {
      field: 'didSummary',
      op: 'isNotNull',
      dataset: 'interactions',
    },
  ],
} satisfies SavedQueryState['data']['params']

export const Route = createFileRoute('/_authenticated/$alias/_app/explore/')({
  component: RouteComponent,
})

function RouteComponent() {
  Route.useSearch()
  useTitle('Explore Interactions')

  return (
    <SavedQueryProvider
      initialValue={INITIAL_VALUE}
      type="explore"
      from="/$alias/explore/"
    >
      <div className="flex h-[calc(100vh-56px)] flex-col">
        <ExploreViews />
        <ExploreCurrentView />
      </div>
    </SavedQueryProvider>
  )
}
